import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../api";
import { AuthContext } from "../../contexts/AuthContext";
import "./Auth.css";

const usStates = [
  { value: "", label: "Select a state" },
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" }
];

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, setCurrentUser } = useContext(AuthContext);

  const [userData, setUserData] = useState({});
  const [missingFields, setMissingFields] = useState([]);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      setError("No authenticated user found. Please log in again.");
      return;
    }
    // Exclude fields that are not part of the profile update form.
    const excludedFields = [
      "first_name",
      "middle_name",
      "last_name",
      "suffix",
      "role",
      "department",
      "team"
    ];
    // Always include "apt" even if it's missing.
    const fieldsToUpdate = Object.keys(currentUser).filter(
      (key) =>
        ((currentUser[key] === null || currentUser[key] === "") && !excludedFields.includes(key)) ||
        key === "apt"
    );
    setMissingFields(fieldsToUpdate);
    setUserData(currentUser);
  }, [currentUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      // No password is needed now; we send userData directly.
      await api.post("/auth/register", userData);
      setMessage("Account registered successfully!");
      setSubmitted(true);
      // Optionally update context with the latest user info.
      setCurrentUser(userData);
      setTimeout(() => navigate("/dashboard"), 2000);
    } catch (err) {
      setError(err.response?.data?.error || "Registration failed.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Complete Your Registration</h2>
      {error && <p className="error">{error}</p>}
      {message && <p className="message">{message}</p>}
      {!submitted && (
        <form onSubmit={handleRegister}>
          {missingFields.map((field) => {
            if (field === "state") {
              return (
                <div key={field} className="form-group">
                  <label htmlFor={field}>STATE</label>
                  <select
                    id={field}
                    name={field}
                    value={userData[field] || ""}
                    onChange={handleChange}
                    required
                  >
                    {usStates.map((stateOption) => (
                      <option key={stateOption.value} value={stateOption.value}>
                        {stateOption.label}
                      </option>
                    ))}
                  </select>
                </div>
              );
            } else if (field === "country") {
              return (
                <div key={field} className="form-group">
                  <label htmlFor={field}>COUNTRY</label>
                  <input
                    id={field}
                    type="text"
                    name={field}
                    value={userData[field] || "us"}
                    onChange={handleChange}
                    required
                  />
                </div>
              );
            } else {
              return (
                <div key={field} className="form-group">
                  <label htmlFor={field}>
                    {field.replace(/_/g, " ").toUpperCase()}
                  </label>
                  <input
                    id={field}
                    type={field === "birthday" ? "date" : "text"}
                    name={field}
                    value={userData[field] || ""}
                    onChange={handleChange}
                    // Mark field as required unless it is "apt"
                    required={field !== "apt"}
                  />
                </div>
              );
            }
          })}
          <button type="submit">Register</button>
        </form>
      )}
    </div>
  );
};

export default Register;
